/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(initialState: { currentUser?: API.CurrentUser } | undefined) {
  const { currentUser } = initialState ?? {};
  // console.log(currentUser?.accessList.indexOf('can_SysUser_Get') ?? -1);
  return {
    can_SysUser_GetPage: (currentUser?.accessList.indexOf('can_SysUser_GetPage') ?? -1) >= 0,
    can_SysUser_Get: (currentUser?.accessList.indexOf('can_SysUser_Get') ?? -1) >= 0,
    can_SysUser_New: (currentUser?.accessList.indexOf('can_SysUser_New') ?? -1) >= 0,
    can_SysUser_Update: (currentUser?.accessList.indexOf('can_SysUser_Update') ?? -1) >= 0,
    can_SysUser_Delete: (currentUser?.accessList.indexOf('can_SysUser_Delete') ?? -1) >= 0,
    can_SysUser_ResetPwd: (currentUser?.accessList.indexOf('can_SysUser_ResetPwd') ?? -1) >= 0,
    can_SysUser_Reset_Password:
      (currentUser?.accessList.indexOf('can_SysUser_Reset_Password') ?? -1) >= 0,

    can_SysMenu_GetPage: (currentUser?.accessList.indexOf('can_SysMenu_GetPage') ?? -1) >= 0,
    can_SysMenu_New: (currentUser?.accessList.indexOf('can_SysMenu_New') ?? -1) >= 0,
    can_SysMenu_Edit: (currentUser?.accessList.indexOf('can_SysMenu_Edit') ?? -1) >= 0,
    can_SysMenu_Delete: (currentUser?.accessList.indexOf('can_SysMenu_Delete') ?? -1) >= 0,

    can_SysRole_GetPage: (currentUser?.accessList.indexOf('can_SysRole_GetPage') ?? -1) >= 0,
    can_SysRole_New: (currentUser?.accessList.indexOf('can_SysRole_New') ?? -1) >= 0,
    can_SysRole_Edit: (currentUser?.accessList.indexOf('can_SysRole_Edit') ?? -1) >= 0,
    can_SysRole_Delete: (currentUser?.accessList.indexOf('can_SysRole_Delete') ?? -1) >= 0,

    can_SysDept_GetPage: (currentUser?.accessList.indexOf('can_SysDept_GetPage') ?? -1) >= 0,
    can_SysDept_New: (currentUser?.accessList.indexOf('can_SysDept_New') ?? -1) >= 0,
    can_SysDept_Edit: (currentUser?.accessList.indexOf('can_SysDept_Edit') ?? -1) >= 0,
    can_SysDept_Delete: (currentUser?.accessList.indexOf('can_SysDept_Delete') ?? -1) >= 0,

    can_SysPost_GetPage: (currentUser?.accessList.indexOf('can_SysPost_GetPage') ?? -1) >= 0,
    can_SysPost_New: (currentUser?.accessList.indexOf('can_SysPost_New') ?? -1) >= 0,
    can_SysPost_Edit: (currentUser?.accessList.indexOf('can_SysPost_Edit') ?? -1) >= 0,
    can_SysPost_Delete: (currentUser?.accessList.indexOf('can_SysPost_Delete') ?? -1) >= 0,

    canDashboard: (currentUser?.accessList.indexOf('canDashboard') ?? -1) >= 0,
    canDashboardWorkplace: (currentUser?.accessList.indexOf('canDashboardWorkplace') ?? -1) >= 0,

    // 代码自动插入标记(勿删)
  };
  // return currentUser?.accessList
}
